import React from 'react'

import styled from 'styled-components/native'
import { ProximaNova } from '../../../../App/Components'

type Props = {
  isShowPrice: boolean
  price: number
}

const ActivityMetaPrice = styled(ProximaNova)<{
  highlightcolor: string
  isShowPrice: boolean
  isShowDuration: boolean
}>`
  font-size: 1em;
  width: 50%;
`

export const ActivityPrice = ({ isShowPrice, price }: Props) => {
  if (!isShowPrice) {
    return null
  }
  if (!price) {
    return null
  }

  return <ActivityMetaPrice>{`€${price}`}</ActivityMetaPrice>
}
